/**
 * Mapping de eventos wa_notify → configuração de UI.
 * Mantido em arquivo separado para fácil expansão quando novos eventos surgirem.
 */

import {
  IconAlertTriangle,
  IconAlertCircle,
  IconCircleCheck,
  IconClockExclamation,
  IconRefresh,
  IconKeyOff,
  IconShieldExclamation,
} from '@tabler/icons-react';

export const SEVERITY_THEME = {
  error: {
    bg: '#fef2f2',
    border: '#fecaca',
    color: '#b91c1c',
    iconColor: '#dc2626',
    label: 'Crítico',
  },
  warning: {
    bg: '#fffbeb',
    border: '#fde68a',
    color: '#92400e',
    iconColor: '#d97706',
    label: 'Atenção',
  },
  info: {
    bg: '#eff6ff',
    border: '#bfdbfe',
    color: '#1e40af',
    iconColor: '#2563eb',
    label: 'Info',
  },
};

/**
 * Eventos que precisam BANNER persistente (severity=error que requer ação).
 * Outros são apenas TOAST + entrada no inbox.
 */
export const BANNER_EVENTS = new Set([
  'cloud_api_token_invalid',
  'cloud_api_webhook_silent',
]);

/**
 * Eventos que precisam MODAL bloqueante (impedem uso até resolver).
 */
export const BLOCKING_EVENTS = new Set([
  'cloud_api_token_invalid',
]);

/**
 * Mapeia evento → ícone para feed/banner/toast.
 */
export const EVENT_ICONS = {
  cloud_api_token_invalid: IconKeyOff,
  cloud_api_token_expiring: IconClockExclamation,
  cloud_api_phone_quality: IconShieldExclamation,
  cloud_api_template_status: IconCircleCheck,
  cloud_api_template_category_changed: IconAlertTriangle,
  cloud_api_meta_alert: IconAlertCircle,
  cloud_api_webhook_silent: IconRefresh,
};

/**
 * Mapeia evento → label human-readable para feed/inbox.
 */
export const EVENT_LABELS = {
  cloud_api_token_invalid: 'Token inválido',
  cloud_api_token_expiring: 'Token expirando',
  cloud_api_phone_quality: 'Qualidade do número',
  cloud_api_template_status: 'Template aprovado/rejeitado',
  cloud_api_template_category_changed: 'Template reclassificado',
  cloud_api_meta_alert: 'Alerta da Meta',
  cloud_api_webhook_silent: 'Webhook silencioso',
};

/**
 * Severidade efetiva considerando dinâmica do payload.
 * Ex: token_expiring com days_left <= 2 sobe para 'error'.
 */
export function effectiveSeverity(alert) {
  const declared = alert.severity || 'info';
  // Pode ter regras dinâmicas no futuro; hoje confiamos no backend.
  return declared;
}

/**
 * Resolve CTA contextual de um alerta.
 * Retorna { label, action } ou null.
 *
 * action: 'open_channel' → navega para a aba Canais > Cloud API > Conectar
 */
export function resolveAlertCTA(alert) {
  if (alert.event === 'cloud_api_token_invalid') {
    return { label: 'Reconectar agora', action: 'open_channel_connect' };
  }
  if (alert.event === 'cloud_api_token_expiring') {
    return { label: 'Renovar token', action: 'open_channel_connect' };
  }
  if (alert.event === 'cloud_api_webhook_silent') {
    return { label: 'Verificar conexão', action: 'open_channel_detail' };
  }
  if (alert.event === 'cloud_api_template_category_changed') {
    return { label: 'Ver template', action: 'open_channel_templates' };
  }
  if (alert.event === 'cloud_api_phone_quality') {
    return { label: 'Ver detalhes', action: 'open_channel_detail' };
  }
  return null;
}
